<template>
	<div class="order-mode-filter-container" :class="{expanded: value > 0 && !this.ordersStore.showCompleted, active: displayActive}" @click="$emit('toggle')">
		<div class="title"><img :src="icon"></div>
		<div class="expandable-value">{{ valueDisplayed }}</div>
	</div>
</template>

<script>
import {useOrdersStore} from "@/console-new/stores/orders.store";

export default {
	setup() {
		const ordersStore = useOrdersStore();
		return { ordersStore }
	},
	name: "OrderModeFilter",
	props: {
		icon: {
			type: String,
			required: true
		},
		value: {
			type: Number,
			default: 0
		},
		active: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		displayActive() {
			return (( this.ordersStore.filterRooms && this.ordersStore.filterDelivery && this.ordersStore.filterTakeaway && this.ordersStore.filterCounter ) ? false : this.active);
		},
		valueDisplayed() {
			if(!this.ordersStore.showCompleted) {
				if(this.value > 999) {
					return "999+";
				} else if(this.value > 0) {
					return this.value;
				}
			}
			return '';
		}
	}
}
</script>

<style lang="scss" scoped>
.order-mode-filter-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	border: 1px solid $primary;
	border-radius: 13px;
	cursor: pointer;

	* {
		pointer-events: none;
		user-select: none;
	}

	.title {
		border-right: 0 solid $primary;
		border-radius: 13px;
		background-color: transparent;
		padding: 6px 12px;
		transition: border-right 0.3s ease-in-out, background-color 0.3s ease-in-out;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
		width: 40px;
		@media (max-width: 340px) {
			width: 36px;
		}

		img {
			width: 16px;
			height: 16px;
		}

		@media (max-width: 500px) {
			padding: 7px 9px;
		}

	}

	&.active {
		.title {
			background-color: var(--color-active-button);
		}
	}

	.expandable-value {
		font-size: 16px;
		color: $primary;
		border-radius: 13px;
		width: auto;
		padding: 7px 0;
		max-width: 0;
		transition: max-width 0.3s ease-in-out 0.1s, padding 0.3s ease-in-out 0.1s;
		overflow: hidden;

	}

	&.expanded {

		.title {
			border-right: 1px solid $primary;
		}

		.expandable-value {
			padding: 7px 8px;
			max-width: 68px;
			text-overflow: ellipsis;
			display: flex;
			align-items: center;

			@media (max-width: 500px) {
				font-size: 14px;
				padding: 8px 5px;
			}
		}

	}

}
</style>